import { H3 } from '@frontend/shadcn/components/typography/h3';
import React from 'react';
import { AutomationExecutionTable } from './components/AutomationExecutionTable';

type TProps = {
  projectId: number;
  isStaOffer?: boolean;
  baseUri?: string;
};

export const RunHistory = (props: TProps) => {
  const { projectId, isStaOffer, baseUri } = props;
  return (
    <div className="p-6 flex flex-col gap-2">
      <H3 className="m-0 font-medium text-lg">Automation Run History</H3>
      <AutomationExecutionTable projectId={projectId} isStaOffer={isStaOffer} baseUri={baseUri} />
    </div>
  );
};
